























































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import CurrencyModule from '@/store/modules/Currency';
import AuthModule from '@/store/modules/Auth';
import Table from '@/components/Table/Index.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import PaymentLogBody from '@/components/Table/PaymentLogBody.vue';
import Pagination from '@/components/Pagination.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
    PaymentLogBody,
  },
})
export default class PaymentLogView extends Mixins(ToolMixin, ErrorHandleMixin, PaginationMixin) {
  StatementInstance = getModule(StatementModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  TableHead = DepositWithdrawData.TableHeadDetail;

  toggleMode = true;

  dataList: any = [];

  footerSummary = [];

  statement: any[] = [];

  currencyRate = {};

  multiCurrency = [];

  totalCurrency: any = [];

  statementCriteria = {
    username: this.AuthInstance.user.username,
    role: this.AuthInstance.user.role,
  };

  startDate = '';

  endDate = '';

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  created() {
    this.fetchStatement();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchStatement();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date)
      .startOf('day')
      .toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date)
      .endOf('day')
      .toDate();
    this.endDate = _endDate;
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchStatement();
  }

  onSubmit() {
    this.fetchStatement();
  }

  switchFullmode() {
    this.toggleMode = !this.toggleMode;
    this.fetchStatement();
  }

  async fetchStatement() {
    this.GeneralInstance.toggleLoading(true);
    const totalCC = await this.CurrencyInstance.fetchCurrencyRate({ data: { currency: '' } });
    this.currencyRate = totalCC.rateCurrency;
    this.multiCurrency = totalCC.currency;
    const criteria = {
      ...this.statementCriteria,
      ...this.Period,
      ...this.PaginationDetail,
      isMultiCurrency: this.toggleMode,
    };
    const { data, status } = await this.StatementInstance.FetchStatementDetail(criteria);
    this.checkError(status);
    this.PaginationDetail.amount = data.pageAmount;
    this.dataList = [...data.report];
    this.footerSummary = this.toggleMode ? [...data.footer] : data.footer;
    this.totalCurrency = this.dataList.map((item: any) => item._id).sort();
    if (!this.totalCurrency.length) this.totalCurrency = [this.$t('report.winloseSimple.datatable.noData')];
    this.GeneralInstance.toggleLoading(false);
  }
}
